var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.30497 4.84275C3.31313 4.76159 3.30219 4.67965 3.27302 4.60348C3.24385 4.52731 3.19726 4.45902 3.13697 4.40408L1.89163 2.89275V2.66675H5.75697L8.74497 9.27008L11.3716 2.66675H15.057V2.89275L13.9923 3.92008C13.9472 3.95491 13.9124 4.00134 13.8916 4.05442C13.8708 4.10749 13.8648 4.16521 13.8743 4.22141V11.7774C13.8648 11.8336 13.8708 11.8913 13.8916 11.9444C13.9124 11.9975 13.9472 12.0439 13.9923 12.0787L15.0323 13.1067V13.3334H9.80297V13.1074L10.8803 12.0541C10.9863 11.9474 10.9863 11.9161 10.9863 11.7534V5.64541L7.99163 13.3081H7.58763L4.10097 5.64541V10.7814C4.0723 10.9967 4.14363 11.2147 4.2943 11.3707L5.69497 13.0827V13.3081H1.72363V13.0827L3.12363 11.3707C3.19771 11.2934 3.25268 11.1999 3.28417 11.0976C3.31565 10.9953 3.32278 10.887 3.30497 10.7814V4.84275Z",
    fill: "#D0CBD0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/Medium.eb82ceb5f7700c96a7e3c7446d9117d9.svg";
export { ForwardRef as ReactComponent };